import { render } from "./StandardV2Home.vue?vue&type=template&id=025faeb7&scoped=true"
import script from "./StandardV2Home.vue?vue&type=script&lang=js"
export * from "./StandardV2Home.vue?vue&type=script&lang=js"

import "./StandardV2Home.vue?vue&type=style&index=0&id=025faeb7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025faeb7"]])

export default __exports__